var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterialUi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29b6f6",
    points: "1,5 7,9 7,29 1,25"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0288d1",
    points: "47,20 41,24 41,37 47,33"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0288d1",
    points: "47,6 41,10 41,17 47,13"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0288d1",
    points: "35,5 29,9 29,29 35,25"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29b6f6",
    points: "1,12 18,23 18,16 1,5"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0288d1",
    points: "35,12 18,23 18,16 35,5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0288d1",
    points: "35,26 18,37 18,30 35,19"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0288d1",
    points: "47,34 30,45 30,38 47,27"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29b6f6",
    points: "30,37.765 18,30 18,37 30,44.765"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialUi);
export default __webpack_public_path__ + "static/media/material-ui.8e8d37c6bebf84512bcbbc9c0c4d8a71.svg";
export { ForwardRef as ReactComponent };